import React from "react";
import { Marker } from "react-leaflet";
import L, { LatLng } from "leaflet";
import pictoTrack from "../../assets/images/picto_track.png";
import pictoInsta from "../../assets/images/picto_insta.png";
import pictoMonument from "../../assets/images/picto_monuments.png";
import pictoRestaurant from "../../assets/images/picto_restaurants.png";
import pictoOther from "../../assets/images/picto_others.png";

// Define image-based marker icons
const iconUrls: { [key: string]: string } = {
    TRACK: pictoTrack,
    INSTA: pictoInsta,
    MONUMENT: pictoMonument,
    RESTAURANT: pictoRestaurant,
    OTHER: pictoOther,
    MUSEUM: pictoMonument,
};

// Create Leaflet icon instances for each type
const icons: { [key: string]: L.Icon } = Object.fromEntries(
    Object.entries(iconUrls).map(([type, url]) => [
        type,
        new L.Icon({
            iconUrl: url,
            iconSize: [32, 32], // Adjust size as needed
            iconAnchor: [16, 32], // Center anchor at bottom
            popupAnchor: [0, -32], // Adjust popup position
        }),
    ]),
) as { [key: string]: L.Icon };

interface ImageMarkerProps {
    id: string;
    lat?: number;
    lng?: number;
    type?: string;
    onSelect: (id: string) => void;
    onMarkerDragEnd: (newPosition: LatLng, id: string) => void;
}

const ImageMarker: React.FC<ImageMarkerProps> = ({ id, lat = 0, lng = 0, type, onSelect, onMarkerDragEnd }) => {
    const location: [number, number] = lat && lng ? [lat, lng] : [0, 0];

    const handleMarkerClick = () => {
        onSelect(id);
    };

    const handleMarkerDragEnd = (e: L.DragEndEvent) => {
        const newPosition: LatLng = e.target.getLatLng();
        onMarkerDragEnd(newPosition, id);
    };

    // Use the provided type-specific icon, or fallback to "OTHER"
    const markerIcon = type && icons[type] ? icons[type] : icons.OTHER;

    return (
        <Marker
            key={id}
            position={location}
            icon={markerIcon}
            eventHandlers={{ click: handleMarkerClick, dragend: handleMarkerDragEnd }}
            draggable={true}
        />
    );
};

export default ImageMarker;
